import PropTypes from 'prop-types';

export default PropTypes.shape({
  uuid: PropTypes.string,
  parentUuid: PropTypes.string,
  productId: PropTypes.string,
  productVersion: PropTypes.string,
  systemIdentifier: PropTypes.string,
  jurisdiction: PropTypes.string,
  systemStatus: PropTypes.string,
  description: PropTypes.string,
  paidThrough: PropTypes.number,
  lastAuthorized: PropTypes.number
});


// WEBPACK FOOTER //
// ./src/shapes/product-instance.js